<template>
  <span class="search-highlight">
    <span v-for="(part, index) in parts" :key="index" :class="{ 'search-highlight__match': part.match }">{{ part.text }}</span>
  </span>
</template>

<script>
export default {
  name: "SearchHighlight",
  props: {
    text: { default: "" },
    query: { type: String, default: "" },
  },
  computed: {
    parts() {
      const value = String(this.text == null ? "" : this.text);
      const query = String(this.query || "").trim();
      if (!query) return [{ text: value, match: false }];

      const parts = [];
      const lowerValue = value.toLowerCase();
      const lowerQuery = query.toLowerCase();
      let start = 0;
      let matchAt = lowerValue.indexOf(lowerQuery);
      while (matchAt !== -1) {
        if (matchAt > start) parts.push({ text: value.slice(start, matchAt), match: false });
        parts.push({ text: value.slice(matchAt, matchAt + query.length), match: true });
        start = matchAt + query.length;
        matchAt = lowerValue.indexOf(lowerQuery, start);
      }
      if (start < value.length) parts.push({ text: value.slice(start), match: false });
      return parts;
    },
  },
};
</script>

<style scoped>
.search-highlight__match { padding: 0 2px; border-radius: 3px; background: #dff3a8; color: #253b28; font-weight: 750; }
</style>
